import { render, staticRenderFns } from "./IdleCard.vue?vue&type=template&id=e8b73610&"
import script from "./IdleCard.vue?vue&type=script&lang=js&"
export * from "./IdleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports